export default __webpack_public_path__ + "67c3165034645ed33d026db298a88afe.gif";